// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d5682296","460":"70fc9d2a","618":"9f06d13b","722":"86b47224","880":"6983b7f7","973":"dd4d8f78"}[chunkId] + ".chunk.js";
};